module.exports = __webpack_public_path__ + "static/media/medium.ee0c6c37.svg";